<script setup>
import {mdiHuman, mdiHumanChild} from "@mdi/js";
import SelectionButtonsInput from "@/components/forms/SelectionButtonsInput.vue";
import SelectionButton from "@/components/forms/SelectionButton.vue";
import {IsChild, IsChildLabel} from "@/choices";

const isChild = defineModel({type: Boolean});
const props = defineProps({
    fieldProps: {
        type: Object,
    },
});
const emit = defineEmits(['submit']);

function submit() {
    emit('submit', isChild.value);
}
</script>

<template>
    <main>
        <h1>{{ pgettext('label', 'Adult or child?') }}</h1>

        <SelectionButtonsInput v-model="isChild" v-bind="fieldProps" size="x-large" :height="72" @select="submit()">
            <SelectionButton :value="IsChild.ADULT" color="primary" :prepend-icon="mdiHuman">
                <strong>{{ IsChildLabel[IsChild.ADULT] }}</strong>
            </SelectionButton>
            <SelectionButton :value="IsChild.CHILD" color="pink" :prepend-icon="mdiHumanChild">
                <strong>{{ IsChildLabel[IsChild.CHILD] }}</strong>
            </SelectionButton>
        </SelectionButtonsInput>

        <p v-if="isChild != null" class="text-center mt-4">
            <v-btn color="green" size="large" @click="submit()">
                <strong>{{ pgettext('action', 'Continue') }}</strong>
            </v-btn>
        </p>
        <p v-else class="text-center text-subtitle-2">
            {{ gettext('To continue, please select one of the options.') }}
        </p>
    </main>
</template>
